function getElement (value, ids) {
  for (var i = 0; i < ids.length; i++) {
    var el = $(ids[i]);
    if (el.val() === value) {
      return el;
    }
  }
  return el;
}

var RegisterCheckinPromptModel = Backbone.Epoxy.Model.extend({
  initialize: function() {
    Backbone.Validation.bind(this, {liveValidation: true});
  },

  computeds: {},

  validation: {
    password: [
      {
        fn: function (value) {
          var el = getElement(value, ["#registerCheckingPasswordInput"]);

          const password = this.get('password');
          const vRes = global.bookedby.helpers.passwordValidate(password);
          if(vRes.isValid) {
            el.attr("aria-invalid", "false");
          } else {
            el.attr("aria-invalid", "true");
            return vRes.errorMsg;
          }
        }
      }
    ],
    confirmPassword: [
      {
        fn: function (value) {
          var el = getElement(value, ["#registerCheckingConfirmPasswordInput"]);

          const confirmPassword = this.get('confirmPassword');
          const password = this.get('password');

          const vRes = global.bookedby.helpers.confirmPasswordValidate(confirmPassword, password);
          if(vRes.isValid) {
            el.attr("aria-invalid", "false");
            return null;
          } else {
            el.attr("aria-invalid", "true");
            return vRes.errorMsg;
          }
        }
      }
    ]
  },

  defaults: {
    client: null,
    password: null,
    confirmPassword: null,
    accepted: false,
    valid: false,
    closed: false,
    isProcessing: false,
    hasErrors: false,
    errorCode: null,
    errorMessage: null,
    confirmationError: false,
    success: false,
    confirmationErrorMessage: null,
    confirmation: '',
    registerButtonText: 'Finish registration',
    registerButtonProgressText: 'Registering...'
  }
});

module.exports = RegisterCheckinPromptModel;
